var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('button',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-sm",on:{"click":_vm.deleteCop}},[_c('i',{staticClass:"fa fa-trash"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }